import { IDefineCommand, IQuery } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ProgramSlot } from './../../global/builders/ap_program_slot_builder';
import { IAPProgramSlotDatasource } from './../../global/datasources/ap_program_slot_datasource';

export type IUpdateProgramSlotCommand = (
  id: ProgramSlot['id'],
  updatingData: Partial<ProgramSlot>
) => ng.IPromise<IQuery[]>;

angular
  .module('capability-ng-academic-planner')
  .factory(
    'updateProgramSlotCommand',
    (defineCommandORM: IDefineCommand, ngAPProgramSlotDatasource: IAPProgramSlotDatasource) =>
      defineCommandORM(
        'updateProgramSlotCommand',
        (deferred, id: ProgramSlot['id'], updatingData: Partial<ProgramSlot>) => {
          const pgmSlot = ngAPProgramSlotDatasource.get(id);
          if (!pgmSlot) {
            deferred.reject('Failed to update slot entry');
            return;
          }
          ngAPProgramSlotDatasource.put(_4.merge({}, pgmSlot, updatingData));
          deferred.resolve();
        }
      )
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/plan/commands/update_program_slot_command.ts